<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">System Configuration</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-settings" />
            System Configuration
          </b-breadcrumb-item>
          <b-breadcrumb-item>
            Role
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CRow v-if="$helper.isRole($availRoles['HO'])">
      <CCol>
        <CCard class="custom-card">
          <CCardBody class="p-0">
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              no-local-sorting no-sort-reset
            >
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(listJobCode)="row">
                <b-form-group
                  class="mb-0"
                >
                  <multiselect 
                    v-model="row.item.listJobCode" 
                    :options="table.jobCodeData.options" 
                    class="mb-0"
                    placeholder="Select an option"
                    :showLabels="false"
                    :loading="!table.jobCodeData.isLoaded"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                    :internalSearch="false"
                    :multiple="true"
                    :preserveSearch="false"
                    @search-change="populateJobCode"
                    @input="onInputJobCode(row.index)"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="noResult">No elements found.</template>
                    <template slot="afterList" v-if="table.jobCodeData.currentPage < table.jobCodeData.totalPages">
                      <div class="text-center custom-cursor-clickable p-2" @click="appendJobCode" v-if="table.jobCodeData.isLoaded">
                        <span class="text-muted">Load More</span>
                      </div>
                      <div class="text-center" v-else>
                        <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                      </div>
                    </template>
                  </multiselect>
                </b-form-group>
              </template>
              <template #cell(action)="row">
                <b-input-group>
                  <b-input-group-prepend>
                    <b-button variant="primary" size="sm" title="Save" @click="saveJobCode(row.index)">
                      <span v-if="!row.item.isLoading">Save</span>
                      <b-spinner small label="Updating..." v-else>Saving...</b-spinner>
                    </b-button>
                  </b-input-group-prepend>
                  <b-input-group-append class="ml-3 pt-2">
                    <!-- <transition name="fade" mode="out-in"> -->
                      <b-icon icon="check-circle-fill" scale="1.5" variant="success" v-if="row.item.checked"></b-icon>
                      <b-icon icon="x-circle-fill" scale="1.5" variant="danger" v-else-if="row.item.checked === false"></b-icon>
                    <!-- </transition> -->
                  </b-input-group-append>
                </b-input-group>
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="table.totalRows" :page="table.currentPage" :options="tablePageOptions" @limit-change="onLimitChange" @page-change="onPageChange" />
            </CCardFooter>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>
  </CContainer>
</template>

<script>
export default {
  name: 'ConfigRoleList',
  data() {
    return {

      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      table: {
        isLoaded: false,
        fields: [
          {key: "roleName", label: "Role", sortable: false, class:"custom-column-config-roleName"},
          {key: "listJobCode", label: "Job Code", sortable: false, class:"custom-column-config-listJobCode"},
          {key: "action", label: "Aksi", sortable: false, class:"custom-column-config-action"}
        ],

        items: [],

        jobCodeData: {
          isLoaded: false,
          isValid: null,
          isRequired: true,
          options: [],
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0,
          lastQuery: '',
        },

        currentPage: 1,
        perPage: 999,
        totalRows: 0,
        totalPages: 1
      },
    }
  },
  methods: {

    onInputJobCode(index) {
      if (this.table.items[index].listJobCode !== this.table.items[index].prevListJobCode) {
        this.table.items[index].checked = null
      }

      // Loop through prevList
      this.table.items[index].prevListJobCode.forEach(prev => {
        let found = false
        let prevValue = prev.value

        // Loop through currentList
        this.table.items[index].listJobCode.forEach(current => {
          if (prev.value == current.value) {
            found = true
          }
        })
        // if found, delete from jobCodesDeleted if exists
        if (found) {
          this.table.items[index].jobCodesDeleted = this.table.items[index].jobCodesDeleted.filter(val => val != prevValue)
        } else{ // If not found, push to jobCodesDeleted
          this.table.items[index].jobCodesDeleted.push(prevValue)
        }
      })
    },

    saveJobCode(index) {
      let selectedRow = this.table.items[index]

      selectedRow.isLoading = true
      selectedRow.checked = null

      let obj = {
        roleId: selectedRow.roleId,
        jobCodes: [],
        jobCodesDeleted: selectedRow.jobCodesDeleted
      }

      switch(selectedRow.roleId) {
          case 1:
            obj.jobCodes.push('FIMS02')
            break
          case 2:
            obj.jobCodes.push('FIMS04')
            break
          case 3:
            obj.jobCodes.push('FIMS03')
            break
          case 4:
            obj.jobCodes.push('FIMS01')
            break
        }

      selectedRow.listJobCode.forEach(jobCode => {
        obj.jobCodes.push(jobCode.value)
      })

      let postUrl = '/jobCode/editJobCodePerRole/'
      this.$axios.post(postUrl, obj).then(response => {
        if(response.status == 200){
          selectedRow.checked = true
          selectedRow.prevListJobCode = this.$lodash.cloneDeep(selectedRow.listJobCode)
          selectedRow.jobCodesDeleted = []
          this.getTableItems(1, index)
        } else{
          selectedRow.checked = false
          this.$helper.toastError(this, "List Role Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "List Role Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "List Role Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        selectedRow.isLoading = false
      })
    },

    async populateJobCode(query = "") {
      this.table.jobCodeData.isLoaded = false
      this.table.jobCodeData.totalPages = 0
      this.table.jobCodeData.totalRows = 0
      this.table.jobCodeData.currentPage = 1
      this.table.jobCodeData.lastQuery = query
      // URL builder
      let getUrl = "/jobCode/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.table.jobCodeData.currentPage - 1, this.table.jobCodeData.perPage)
      if(query !== ""){
        params['filterType'] = "jobName"
        params['filterValue'] = query
      }

      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.table.jobCodeData.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.table.jobCodeData.options.push({ value: response.data.data.data[i].jobCode, text: response.data.data.data[i].jobName })
            }
            this.table.jobCodeData.totalRows = response.data.data.totalElements
            this.table.jobCodeData.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.table.jobCodeData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    appendJobCode() {
      this.table.jobCodeData.isLoaded = false
      // URL builder
      let getUrl = "/jobCode/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.table.jobCodeData.currentPage, this.table.jobCodeData.perPage)
      if(this.table.jobCodeData.lastQuery !== ""){
        params['filterType'] = "jobName"
        params['filterValue'] = this.table.jobCodeData.lastQuery
      }
      
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.table.jobCodeData.options.push({ value: response.data.data.data[i].jobCode, text: response.data.data.data[i].jobName })
            }
            this.table.jobCodeData.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.table.jobCodeData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    onLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getTableItems()
      }
    },
  
    onPageChange(newPage) {
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getTableItems(newPage)
      }
    },

    getTableItems(page = 1, checkedIndex = null) {
      this.table.isLoaded = false
      this.table.items = []
      if(isNaN(page)) {
        this.table.currentPage = 1
      }
      else {
        this.table.currentPage = page
      }
      // URL builder
      let getUrl = "/jobCode/getRoleJobCode"

      let params = this.$helper.getBasePagedQuery(this.table.currentPage - 1, this.table.perPage)

      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          let idx = 0
          this.table.items = response.data.data.map(obj => {

            obj.checked = null
            obj.jobCodesDeleted = []
            if (!isNaN(checkedIndex)) {
              if (checkedIndex == idx) {
                obj.checked = true
              }
            }
            switch(obj.roleId) {
              case 1:
                obj.listJobCode = obj.listJobCode.filter(jobCode => jobCode.value != 'FIMS02')
                break
              case 2:
                obj.listJobCode = obj.listJobCode.filter(jobCode => jobCode.value != 'FIMS04')
                break
              case 3:
                obj.listJobCode = obj.listJobCode.filter(jobCode => jobCode.value != 'FIMS03')
                break
              case 4:
                obj.listJobCode = obj.listJobCode.filter(jobCode => jobCode.value != 'FIMS01')
                break
            }
            obj.isLoading = false
            obj.prevListJobCode = this.$lodash.cloneDeep(obj.listJobCode)
            obj.jobCodesDeleted = []
            idx++

            return obj
          })
          this.table.totalRows = response.data.data.length
          this.table.totalPages = 1
          // document.getElementsByClassName("multiselect__input")[0].setAttribute("maxlength", "50")
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "List Role Job Code Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "List Role Job Code Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "List Role Job Code Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
      })
    },
  
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },
  },

  async created(){
    await this.populateJobCode()

    this.getTableItems()
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>